module.exports = __webpack_public_path__ + "images/enable-surfaces-23b6da40d8ba6005c34895b52d40006b.jpg";